import _slicedToArray from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _toConsumableArray from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _inherits from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _setPrototypeOf from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/setPrototypeOf";
import _defineProperty from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import moment from 'moment';
import { eventCodeTypesFromOid } from '../../utils/eventCodes';
import { isReady } from '../common';
export var documentStatuses = {
  ALL: 0,
  APPROVED: 1,
  DEPRECATED: 2,
  ARCHIVED: 4
};
export var findDocumentParamsDefault = {
  status: documentStatuses.APPROVED,
  submissionStartDate: '',
  submissionStartDateHour: '00:00:00',
  submissionEndDate: '',
  submissionEndDateHour: '23:59:59',
  creationStartDate: '',
  creationStartDateHour: '00:00:00',
  creationEndDate: '',
  creationEndDateHour: '23:59:59',
  actStartDate: '',
  actStartDateHour: '00:00:00',
  actEndDate: '',
  actEndDateHour: '23:59:59',
  patientHidden: false,
  guardianHidden: false,
  healthcareProfessionalHidden: false,
  categories: null,
  selectedDateRangePreset: 'default',
  showCategoryFilters: false,
  title: '',
  author: '',
  specialty: '',
  sortDate: 'submissionDate'
};
export var documentStatusesLabel = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, documentStatuses.ALL, 'Tous'), documentStatuses.APPROVED, 'Approuvé'), documentStatuses.DEPRECATED, 'Obsolète'), documentStatuses.ARCHIVED, 'Archivé');
export var documentVisibilityStatuses = {
  ALL: 0,
  NORMAL: 1,
  PATIENT_HIDDEN: 2,
  HEALTCARE_PROFESSIONAL_HIDDEN: 4,
  GUARDIAN_HIDDEN: 8
};
var uniqueUUidSeparator = '__';
export var isHiddenFor = function isHiddenFor(visibility, populationVisibityStatus) {
  return (visibility & populationVisibityStatus) === populationVisibityStatus;
};
export var calculateVisibility = function calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden) {
  var forUpload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!patientHidden && !healthcareProfessionalHidden && !guardianHidden) {
    return forUpload ? documentVisibilityStatuses.NORMAL : null;
  }
  return (patientHidden ? documentVisibilityStatuses.PATIENT_HIDDEN : 0) + (healthcareProfessionalHidden ? documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN : 0) + (guardianHidden ? documentVisibilityStatuses.GUARDIAN_HIDDEN : 0);
};

/**
 * Test if ps owns the document
 * @param document
 * @param psId
 * @returns {*}
 */
export var ownsDocument = function ownsDocument(document, psId) {
  return document.Authors.some(function (item) {
    return item.s_hpInternalId === psId;
  });
};
var formatDate = function formatDate(date) {
  var _date$match = date.match( /*#__PURE__*/_wrapRegExp(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})(.*)/, {
      day: 1,
      month: 2,
      year: 3
    })),
    _date$match$groups = _date$match.groups,
    day = _date$match$groups.day,
    month = _date$match$groups.month,
    year = _date$match$groups.year;
  if (day === '00' && month === '00') {
    return year;
  }
  if (day === '00') {
    return "".concat(year).concat(month);
  }
  return moment(date, 'DD/MM/YYYYHH:mm:ss').utc().format('YYYYMMDDHHmmss');
};
export var searchParamsToReferenceIds = function searchParamsToReferenceIds(params) {
  // format referencesIDS
  var referenceIds = [];
  if (params.accessionNumberID && params.accessionNumberOID) {
    referenceIds.push({
      i_approxIdentifier: 0,
      s_identifier: params.accessionNumberID,
      s_oid: params.accessionNumberOID,
      s_typecode: 'urn:ihe:iti:xds:2013:accession'
    });
  }
  if (params.orderNumberID && params.orderNumberOID) {
    referenceIds.push({
      i_approxIdentifier: 0,
      s_identifier: params.orderNumberID,
      s_oid: params.orderNumberOID,
      s_typecode: 'urn:ihe:iti:xds:2013:order'
    });
  }
  if (params.studyInstanceIdID && params.studyInstanceIdOID) {
    referenceIds.push({
      i_approxIdentifier: 0,
      s_identifier: params.studyInstanceIdID,
      s_oid: params.studyInstanceIdOID,
      s_typecode: 'urn:ihe:iti:xds:2016:studyInstanceUID'
    });
  }
  return referenceIds;
};
export var formatSearchParams = function formatSearchParams(findDocumentsParams) {
  var ins = findDocumentsParams.ins,
    status = findDocumentsParams.status,
    submissionStartDate = findDocumentsParams.submissionStartDate,
    submissionEndDate = findDocumentsParams.submissionEndDate,
    creationStartDate = findDocumentsParams.creationStartDate,
    creationEndDate = findDocumentsParams.creationEndDate,
    actStartDate = findDocumentsParams.actStartDate,
    actEndDate = findDocumentsParams.actEndDate,
    submissionStartDateHour = findDocumentsParams.submissionStartDateHour,
    submissionEndDateHour = findDocumentsParams.submissionEndDateHour,
    creationStartDateHour = findDocumentsParams.creationStartDateHour,
    creationEndDateHour = findDocumentsParams.creationEndDateHour,
    actStartDateHour = findDocumentsParams.actStartDateHour,
    actEndDateHour = findDocumentsParams.actEndDateHour,
    patientHidden = findDocumentsParams.patientHidden,
    healthcareProfessionalHidden = findDocumentsParams.healthcareProfessionalHidden,
    guardianHidden = findDocumentsParams.guardianHidden,
    _findDocumentsParams$ = findDocumentsParams.categories,
    categories = _findDocumentsParams$ === void 0 ? [] : _findDocumentsParams$,
    lastSearchTimestamp = findDocumentsParams.lastSearchTimestamp,
    modalityImagery = findDocumentsParams.modalityImagery,
    anatomyImagery = findDocumentsParams.anatomyImagery,
    ReferenceIds = findDocumentsParams.ReferenceIds;
  var submissionStartDatetime = null;
  if (!submissionStartDate && !submissionEndDate && !creationStartDate && !creationEndDate && !actStartDate && !actEndDate && lastSearchTimestamp) {
    var lastSearchTimestampMoment = moment(lastSearchTimestamp).utc();
    submissionStartDatetime = lastSearchTimestampMoment.format('YYYYMMDDHHmmss');
  } else if (submissionStartDate) {
    submissionStartDatetime = formatDate(submissionStartDate + submissionStartDateHour);
  }
  var EventCodes = [];
  if (anatomyImagery) {
    try {
      var anatomy = JSON.parse(anatomyImagery);
      EventCodes = [].concat(_toConsumableArray(EventCodes), _toConsumableArray(anatomy.map(function (a) {
        return {
          s_code: a.s_code,
          s_classification: eventCodeTypesFromOid[a.s_codeSystem]
        };
      })));
    } catch (e) {
      console.log('error parsing EventCodes', e.message);
    }
  }
  if (modalityImagery) {
    try {
      var modality = JSON.parse(modalityImagery);
      EventCodes = [].concat(_toConsumableArray(EventCodes), _toConsumableArray(modality.map(function (a) {
        return {
          s_code: a.s_code,
          s_classification: eventCodeTypesFromOid[a.s_codeSystem]
        };
      })));
    } catch (e) {
      console.log('error parsing EventCodes', e.message);
    }
  }
  return {
    s_ins: ins,
    i_visibility: calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden),
    i_status: status,
    s_submissionDateBottom: submissionStartDatetime,
    s_submissionDateTop: submissionEndDate ? formatDate(submissionEndDate + submissionEndDateHour) : null,
    s_creationDateBottom: creationStartDate ? formatDate(creationStartDate + creationStartDateHour) : null,
    s_creationDateTop: creationEndDate ? formatDate(creationEndDate + creationEndDateHour) : null,
    s_serviceStopDateTop: actEndDate ? formatDate(actEndDate + actEndDateHour) : null,
    s_serviceStartDateBottom: actStartDate ? formatDate(actStartDate + actStartDateHour) : null,
    Categories: categories.reduce(function (obj, item, index) {
      return _objectSpread(_defineProperty({}, "#".concat(index), item), obj);
    }, {}),
    EventCodes: EventCodes,
    ReferenceIds: ReferenceIds
  };
};
export var getUniqueUUid = function getUniqueUUid(uniqueId, uuid) {
  return "".concat(uniqueId).concat(uniqueUUidSeparator).concat(uuid);
};
export var explodeUniqueUUid = function explodeUniqueUUid(uniqueUUid) {
  var _uniqueUUid$split = uniqueUUid.split(uniqueUUidSeparator),
    _uniqueUUid$split2 = _slicedToArray(_uniqueUUid$split, 2),
    uniqueId = _uniqueUUid$split2[0],
    uuid = _uniqueUUid$split2[1];
  return {
    uniqueId: uniqueId,
    uuid: uuid
  };
};
export var findDocumentByUniqueUUid = function findDocumentByUniqueUUid(documents, uniqueUUid) {
  return documents[uniqueUUid] || {};
};
export var findDocumentByUniqueId = function findDocumentByUniqueId(documents, uniqueId) {
  var exeptUuid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var docArray = Object.values(documents);
  return docArray.filter(function (document) {
    return document.s_uniqueId === uniqueId && (!exeptUuid || exeptUuid && document.s_uuid !== exeptUuid);
  });
};
export var findNewDocuments = function findNewDocuments(documents) {
  var docArray = Object.values(documents);
  return docArray.filter(function (document) {
    return document.isNew === true;
  });
};
export var getDocumentData = function getDocumentData(documentContent) {
  if (documentContent && documentContent.s_status === 'OK') {
    return documentContent.s_fileContentInBase64;
  }
  return null;
};
export var getCdaHeaders = function getCdaHeaders(documentContent) {
  if (documentContent && documentContent.s_status === 'OK') {
    return documentContent.s_cdaHeadersInBase64;
  }
  return null;
};
export var isMetaCategorySelected = function isMetaCategorySelected(selectedCategories, metaCategory) {
  if (!metaCategory) {
    return false;
  }
  if (selectedCategories === null) {
    return false;
  }
  if (selectedCategories.length === 0) {
    return true;
  }
  var childrenCategories = metaCategory.types;
  return childrenCategories.some(function (category) {
    return selectedCategories.includes(category.code);
  });
};
export var getFilteredMetaCategoriesIndex = function getFilteredMetaCategoriesIndex(metaCategories, selectedCategories) {
  var selectedMetas = [];
  if (!metaCategories) {
    return selectedMetas;
  }
  metaCategories.forEach(function (meta, index) {
    if (isMetaCategorySelected(selectedCategories, meta)) {
      selectedMetas.push(index);
    }
  });
  return selectedMetas;
};
export var isMetaCategoryFullyFiltered = function isMetaCategoryFullyFiltered(selectedCategories, metaCategory) {
  if (!metaCategory) {
    return false;
  }
  if (selectedCategories === null) {
    return false;
  }
  if (selectedCategories.length === 0) {
    return true;
  }
  var _metaCategory$types = metaCategory.types,
    childrenCategories = _metaCategory$types === void 0 ? [] : _metaCategory$types;
  return childrenCategories.every(function (category) {
    return selectedCategories.includes(category.code);
  });
};
export var getFullyFilteredMetaCategoriesIndex = function getFullyFilteredMetaCategoriesIndex(metaCategories, selectedCategories) {
  var selectedMetas = [];
  if (!metaCategories) {
    return selectedMetas;
  }
  metaCategories.forEach(function (meta, index) {
    if (isMetaCategoryFullyFiltered(selectedCategories, meta)) {
      selectedMetas.push(index);
    }
  });
  return selectedMetas;
};

/**
 * get the submission start date according to EX_3.1-1020
 * (cache the search results, and search only documents submitted since the last search timestamp)
 * @param findDocuments
 * @param findDocumentsParams
 * @return moment.Moment
 */
export var getDefaultSubmissionStartDate = function getDefaultSubmissionStartDate(findDocuments, findDocumentsParams) {
  var submissionStartDateHour = findDocumentsParams.submissionStartDateHour,
    submissionStartDate = findDocumentsParams.submissionStartDate;
  if (submissionStartDate) {
    return moment(submissionStartDate + submissionStartDateHour, 'DD/MM/YYYYHH:mm:ss');
  }
  if (isReady(findDocuments)) {
    var updatedAt = findDocuments.updatedAt;
    return moment(updatedAt);
  }
  return null;
};
var getDateFilter = function getDateFilter(columnName, startDate, startDateHour, endDate, endDateHour) {
  return {
    id: columnName,
    type: 'date',
    datemin: startDate ? moment(startDate + startDateHour, 'DD/MM/YYYYHH:mm:ss') : moment(0),
    datemax: endDate ? moment(endDate + endDateHour, 'DD/MM/YYYYHH:mm:ss') : moment()
  };
};
export var findDocumentParamsToFilters = function findDocumentParamsToFilters(params) {
  var status = params.status,
    submissionStartDate = params.submissionStartDate,
    submissionStartDateHour = params.submissionStartDateHour,
    submissionEndDate = params.submissionEndDate,
    submissionEndDateHour = params.submissionEndDateHour,
    creationStartDate = params.creationStartDate,
    creationStartDateHour = params.creationStartDateHour,
    creationEndDate = params.creationEndDate,
    creationEndDateHour = params.creationEndDateHour,
    actStartDate = params.actStartDate,
    actStartDateHour = params.actStartDateHour,
    actEndDate = params.actEndDate,
    actEndDateHour = params.actEndDateHour,
    patientHidden = params.patientHidden,
    guardianHidden = params.guardianHidden,
    healthcareProfessionalHidden = params.healthcareProfessionalHidden,
    categories = params.categories,
    title = params.title,
    author = params.author;
  var filters = [];
  filters.push({
    id: 'i_document_Visibility',
    type: 'value',
    value: calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden)
  });
  filters.push({
    id: 's_typeCode',
    type: 'array',
    array: categories
  });
  if (creationStartDate || creationEndDate) {
    filters.push(getDateFilter('s_creationDate', creationStartDate, creationStartDateHour, creationEndDate, creationEndDateHour));
  }
  if (actStartDate || actEndDate) {
    filters.push(getDateFilter('s_serviceStartDate', actStartDate, actStartDateHour, actEndDate, actEndDateHour));
    filters.push(getDateFilter('s_serviceStopDate', actStartDate, actStartDateHour, actEndDate, actEndDateHour));
  }
  if (submissionStartDate || submissionEndDate) {
    filters.push(getDateFilter('s_submissionDate', submissionStartDate, submissionStartDateHour, submissionEndDate, submissionEndDateHour));
  }
  filters.push({
    id: 'i_document_Status',
    type: 'value',
    value: status
  });
  filters.push({
    id: 's_title',
    type: 'string',
    value: title
  });
  filters.push({
    id: 'Authors',
    type: 'authors',
    value: author
  });
  return filters;
};
export var filterDocument = function filterDocument(filter, document) {
  var id = filter.id,
    _filter$value = filter.value,
    value = _filter$value === void 0 ? null : _filter$value,
    _filter$datemin = filter.datemin,
    datemin = _filter$datemin === void 0 ? null : _filter$datemin,
    _filter$datemax = filter.datemax,
    datemax = _filter$datemax === void 0 ? null : _filter$datemax,
    array = filter.array,
    type = filter.type;
  if (type === 'array') {
    return array !== null && (array.length === 0 || array.indexOf(document[id]) > -1);
  }
  if (type === 'value' && value && value !== 0) {
    return document[id] === value;
  }
  if (type === 'date' && (datemin || datemax)) {
    var momentValue = moment(document[id], 'YYYYMMDDHHmmss');
    return momentValue.isBetween(datemin, datemax, null, '[]');
  }
  if (type === 'string' && value) {
    return document[id].toLowerCase().indexOf(value.toLowerCase()) !== -1;
  }
  if (type === 'authors' && value) {
    return document.Authors.findIndex(function (author) {
      return author.s_hpName.concat(author.s_hpGiven).toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }) !== -1;
  }
  return true;
};
export var getCategoryCounts = function getCategoryCounts(metaCategories, documents) {
  if (documents === undefined) {
    return metaCategories;
  }
  var categoryCount = Object.values(documents).reduce(function (acc, curr) {
    acc[curr.s_typeCode] = acc[curr.s_typeCode] || {
      count: 0,
      new: 0
    };
    acc[curr.s_typeCode].count += 1;
    if (curr.isNew === true) {
      acc[curr.s_typeCode].new += 1;
    }
    return acc;
  }, {});
  var metaCategoriesCount = [];
  metaCategories.forEach(function (meta, index) {
    // JSON.parse(JSON.stringify(meta)) pour copier l'objet sans référence
    metaCategoriesCount[index] = _objectSpread({}, JSON.parse(JSON.stringify(meta)), {
      count: 0,
      new: 0
    });
    meta.types.forEach(function (category, indexCat) {
      var count = categoryCount[category.code] || {
        count: 0,
        new: 0
      };
      metaCategoriesCount[index].types[indexCat] = _objectSpread({}, category, count);
      metaCategoriesCount[index].count += count.count;
      metaCategoriesCount[index].new += count.new;
    });
  });
  return metaCategoriesCount;
};
export var getFilteredDocuments = function getFilteredDocuments(documents, params) {
  var filters = findDocumentParamsToFilters(params);
  return Object.values(documents).filter(function (document) {
    return filters.every(function (filter) {
      return filterDocument(filter, document);
    });
  });
};
export var getFindDocumentsParams = function getFindDocumentsParams(state) {
  var params = state.dmpconnectUser.findDocumentsParams;
  return _objectSpread({}, params);
};
export var getFindDocumentsLastSearchTimeStamp = function getFindDocumentsLastSearchTimeStamp(state) {
  var ins = state.dmpconnect.selectedIns,
    _state$dmpconnectUser = state.dmpconnectUser.findDocumentsCache,
    _state$dmpconnectUser2 = _state$dmpconnectUser === void 0 ? {} : _state$dmpconnectUser,
    _state$dmpconnectUser3 = _state$dmpconnectUser2[ins],
    _state$dmpconnectUser4 = _state$dmpconnectUser3 === void 0 ? {} : _state$dmpconnectUser3,
    _state$dmpconnectUser5 = _state$dmpconnectUser4.timestamp,
    lastSearchTimestamp = _state$dmpconnectUser5 === void 0 ? null : _state$dmpconnectUser5;
  return lastSearchTimestamp;
};